import React               from "react"

import IconLockingSystem   from "../common/Icons/LockingSystem"

import ItemViewHeader      from "../common/Headers/ItemViewHeader"
import ItemGroupApiLink    from "./ItemGroupApiLink"
import LockingSystem       from "../../types/LockingSystem"
import CollectionsList     from "./Sync/CollectionsList"
import SyncHeader          from "./Sync/Header";
import {useLockingSystems} from "../../contexts/LockingSystemContext";

export interface props {
    item: LockingSystem;
}

const View: React.FC<props> = ({ item }: props) => {

    const {fetchItems, isSynchronizing, syncEnd} = useLockingSystems()

    const
        viewHeaderIcon = <IconLockingSystem link={'/locking-systems/' + item.id + '/form'}
                                    size="large" text={item.name} />,
        viewHeaderTitle: string     = item?.name,
        viewHeaderSubTitle: string  = item?.lockingSystemType?.brand.name + ' - ' + item?.lockingSystemType?.name

    React.useEffect(() => {

        const interval = setInterval(() => {

            if (isSynchronizing === 'lockingSystem') {
                fetchItems('', true)

                if (item.lockingSystemSyncState?.lockedAt === null &&
                    item.lockingSystemSyncState?.allSecondsAgo && item.lockingSystemSyncState?.allSecondsAgo < 60) {
                    syncEnd()
                } else {
                    // console.log('isSynchonizing: ' + isSynchronizing)
                    // console.log('lockedAt: ' + item.lockingSystemSyncState?.lockedAt)
                    // console.log('lockedCollection: ' + item.lockingSystemSyncState?.lockedCollection)
                    // console.log('allAt: ' + item.lockingSystemSyncState?.allAt)
                    // console.log('allSecondsAgo: ' + item.lockingSystemSyncState?.allSecondsAgo)
                }
            }

        }, 1000, isSynchronizing, item)

        return () => clearInterval(interval)

    }, [item, isSynchronizing])

    return (
        <div className="ion-text-center">
            <ItemViewHeader icon={viewHeaderIcon} title={viewHeaderTitle} subTitle={viewHeaderSubTitle} />
            <SyncHeader  item={item} />
            <CollectionsList item={item} />
            {item.lockingSystemApi?.id === 3 && <ItemGroupApiLink item={item} />}
            <div className="ion-padding-top">&nbsp;</div>
        </div>
    );
}

export default View